import * as FaIcons from 'react-icons/fa6';

// A comprehensive curated list of FontAwesome Icons for Amenities & Bookings
export const AMENITY_ICONS = [
  // Events & Celebrations
  { value: 'champagne-glasses', label: 'Celebration', icon: FaIcons.FaChampagneGlasses },
  { value: 'calendar-check', label: 'Event/Party', icon: FaIcons.FaCalendarCheck },
  { value: 'heart', label: 'Wedding/Heart', icon: FaIcons.FaHeart },
  { value: 'cake-candles', label: 'Birthday/Cake', icon: FaIcons.FaCakeCandles },
  { value: 'gift', label: 'Festival/Gift', icon: FaIcons.FaGift },
  
  // Sports & Fitness
  { value: 'baseball-bat-ball', label: 'Cricket/Baseball', icon: FaIcons.FaBaseballBatBall },
  { value: 'table-tennis-paddle-ball', label: 'Tennis/Racquet', icon: FaIcons.FaTableTennisPaddleBall },
  { value: 'basketball', label: 'Basketball', icon: FaIcons.FaBasketball },
  { value: 'futbol', label: 'Soccer/Football', icon: FaIcons.FaFutbol },
  { value: 'volleyball', label: 'Volleyball', icon: FaIcons.FaVolleyball },
  { value: 'dumbbell', label: 'Gym/Fitness', icon: FaIcons.FaDumbbell },
  { value: 'person-running', label: 'Track/Running', icon: FaIcons.FaPersonRunning },
  { value: 'person-biking', label: 'Cycling', icon: FaIcons.FaPersonBiking },
  { value: 'person-swimming', label: 'Swimming Pool', icon: FaIcons.FaPersonSwimming },
  { value: 'gamepad', label: 'Gaming/Esports', icon: FaIcons.FaGamepad },
  
  // Recreation & Wellness
  { value: 'spa', label: 'Spa/Massage', icon: FaIcons.FaSpa },
  { value: 'yin-yang', label: 'Yoga/Meditation', icon: FaIcons.FaYinYang },
  { value: 'tree', label: 'Park/Garden', icon: FaIcons.FaTree },
  { value: 'leaf', label: 'Nature Walk', icon: FaIcons.FaLeaf },
  { value: 'child-reaching', label: 'Kids Area/Play', icon: FaIcons.FaChildReaching },
  { value: 'book-open', label: 'Library/Reading', icon: FaIcons.FaBookOpen },
  { value: 'film', label: 'Theater/Movie', icon: FaIcons.FaFilm },
  { value: 'music', label: 'Music/Dance', icon: FaIcons.FaMusic },
  
  // Business & Meetings
  { value: 'handshake', label: 'Meeting Room', icon: FaIcons.FaHandshake },
  { value: 'briefcase', label: 'Conference/Business', icon: FaIcons.FaBriefcase },
  { value: 'users', label: 'Community Gather', icon: FaIcons.FaUsers },
  { value: 'laptop-code', label: 'Workspace', icon: FaIcons.FaLaptopCode },
  
  // Utilities & Others
  { value: 'square-parking', label: 'Parking', icon: FaIcons.FaSquareParking },
  { value: 'utensils', label: 'Dining/Restaurant', icon: FaIcons.FaUtensils },
  { value: 'mug-hot', label: 'Cafe/Coffee', icon: FaIcons.FaMugHot },
  { value: 'kit-medical', label: 'Medical/First Aid', icon: FaIcons.FaKitMedical },
  { value: 'shop', label: 'Store/Shop', icon: FaIcons.FaShop },
  { value: 'paw', label: 'Pet Area', icon: FaIcons.FaPaw },
  { value: 'ellipsis', label: 'Other/Misc', icon: FaIcons.FaEllipsis },
];

// Helper to render icon component given the string value
export const getIconComponent = (iconValue) => {
  const found = AMENITY_ICONS.find(i => i.value === iconValue);
  const IconCmp = found && found.icon ? found.icon : FaIcons.FaEllipsis;
  return IconCmp ? <IconCmp /> : null;
};
